(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticker-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-configurator')) {
    customElements.define('sticker-configurator', class extends HTMLElement {
      connectedCallback() {
        this.product = JSON.parse(this.querySelector('[data-product-json]').textContent);
        this.form = document.getElementById(this.dataset.formId);
        this.variantInput = this.querySelector('[data-variant-id]');
        this.quantityList = this.querySelector('[data-quantity-list]');
        this.summary = this.querySelector('[data-configurator-summary]');
        this.summaryList = this.querySelector('[data-summary-list]');
        this.summaryCompact = this.querySelector('[data-summary-compact]');
        this.summarySets = this.querySelector('[data-summary-sets]');
        this.summaryStickerCountRow = this.querySelector('[data-summary-sticker-count-row]');
        this.summaryStickerCount = this.querySelector('[data-summary-sticker-count]');
        this.summaryTotal = this.querySelector('[data-summary-total]');
        this.summaryUnit = this.querySelector('[data-summary-unit]');
        this.summaryUnitValue = this.querySelector('[data-summary-unit-value]');
        this.submitButton = this.querySelector('[data-configurator-submit]');
        this.validation = this.querySelector('[data-configurator-validation]');
        this.errorList = this.querySelector('[data-configurator-errors]');
        this.setQuantityInput = this.querySelector('[data-set-quantity]');
        this.sizePosition = Number(this.dataset.sizePosition);
        this.finishPosition = Number(this.dataset.finishPosition);
        this.quantityPosition = Number(this.dataset.quantityPosition);
        this.optionMappingValid = this.dataset.optionMappingValid === 'true';
        const initialVariant = this.product.variants.find((variant) => String(variant.id) === this.dataset.selectedVariantId);
        this.selectedQuantity = initialVariant?.options?.[this.quantityPosition - 1] || null;
        this.currentVariant = initialVariant || null;

        this.optionInputs = Array.from(this.querySelectorAll('[data-configurator-option]'));
        this.productionPropertyInputs = Array.from(this.querySelectorAll('[data-production-property]'));
        this.optionInputs.forEach((input) => input.addEventListener('change', () => this.refresh()));
        this.productionPropertyInputs.forEach((input) => input.addEventListener('change', () => {
          this.renderSummary(this.selections, this.currentVariant);
        }));
        this.quantityList?.addEventListener('change', (event) => {
          if (!event.target.matches('[data-quantity-input]')) return;
          this.selectedQuantity = event.target.value;
          this.refresh();
        });
        this.setQuantityInput?.addEventListener('input', () => {
          this.renderSummary(this.selections, this.currentVariant);
        });
        this.setQuantityInput?.addEventListener('change', () => {
          this.setQuantityInput.value = String(this.setCount);
          this.renderSummary(this.selections, this.currentVariant);
        });

        this.form?.addEventListener('submit', (event) => this.validateSubmission(event), { capture: true });
        this.form?.addEventListener('formdata', (event) => {
          Array.from(event.formData.keys()).forEach((key) => {
            if (key.startsWith('sticker-selection-') || key.startsWith('sticker-quantity-')) {
              event.formData.delete(key);
            }
          });
        });
        this.form?.addEventListener('cart:error', (event) => this.showErrors([event.detail.error]));
        this.setupModules();
        this.refresh();
      }

      get selections() {
        const values = {};
        this.optionInputs.filter((input) => input.checked).forEach((input) => {
          values[Number(input.dataset.optionPosition)] = input.value;
        });
        if (this.selectedQuantity) values[this.quantityPosition] = this.selectedQuantity;
        return values;
      }

      get setCount() {
        return Math.max(1, Number.parseInt(this.setQuantityInput?.value, 10) || 1);
      }

      variantsForSelections(selections, ignoredPosition = 0) {
        return this.product.variants.filter((variant) => Object.entries(selections).every(([position, value]) => {
          const numericPosition = Number(position);
          return numericPosition === ignoredPosition || variant.options[numericPosition - 1] === value;
        }));
      }

      refresh() {
        const baseSelections = this.selections;
        delete baseSelections[this.quantityPosition];
        this.refreshOptionAvailability(baseSelections);
        const quantityVariants = this.variantsForSelections(baseSelections);
        this.renderQuantityChoices(quantityVariants);

        const completeSelections = { ...baseSelections };
        if (this.selectedQuantity) completeSelections[this.quantityPosition] = this.selectedQuantity;

        const resolvedVariant = this.variantsForSelections(completeSelections).find((variant) => variant.available) || null;
        this.commitVariant(resolvedVariant);
        this.renderSummary(completeSelections, resolvedVariant);
        this.clearErrors();
      }

      refreshOptionAvailability(selections) {
        this.optionInputs.forEach((input) => {
          const position = Number(input.dataset.optionPosition);
          const proposedSelections = { ...selections, [position]: input.value };
          const available = this.variantsForSelections(proposedSelections, this.quantityPosition).some((variant) => variant.available);
          input.disabled = !available;
        });
      }

      renderQuantityChoices(variants) {
        if (!this.quantityList) return;

        const choices = [];
        const seen = new Set();
        variants.forEach((variant) => {
          const value = variant.options[this.quantityPosition - 1];
          if (seen.has(value)) return;
          seen.add(value);
          choices.push({ value, variant });
        });

        if (this.selectedQuantity && !choices.some((choice) => choice.value === this.selectedQuantity && choice.variant.available)) {
          this.selectedQuantity = null;
        }

        this.quantityList.replaceChildren(...choices.map((choice, index) => {
          const units = this.parseUnits(choice.value);
          const wrapper = document.createElement('div');
          const input = document.createElement('input');
          const label = document.createElement('label');
          const id = `sticker-quantity-${this.dataset.sectionId}-${index}`;

          input.className = 'sr-only sticker-configurator__quantity-input';
          input.type = 'radio';
          input.id = id;
          input.name = `sticker-quantity-${this.dataset.sectionId}`;
          input.value = choice.value;
          input.dataset.quantityInput = '';
          input.checked = choice.value === this.selectedQuantity;
          input.disabled = !choice.variant.available;

          label.className = 'sticker-configurator__quantity-row';
          label.htmlFor = id;

          const quantity = document.createElement('span');
          quantity.className = 'bold';
          quantity.textContent = choice.value;

          const total = document.createElement('span');
          total.className = 'bold';
          total.textContent = choice.variant.available ? this.formatMoney(choice.variant.price) : this.dataset.unavailableLabel;

          const unit = document.createElement('span');
          unit.className = 'text-sm text-subdued';
          unit.textContent = choice.variant.available && units ? `${this.formatMoney(choice.variant.price / units)} ${this.dataset.eachLabel}` : '—';

          label.append(quantity, total, unit);
          wrapper.append(input, label);
          return wrapper;
        }));
      }

      commitVariant(variant) {
        const previousVariant = this.currentVariant;
        this.currentVariant = variant;
        this.variantInput.value = variant?.id || '';
        this.submitButton.disabled = !variant || !this.optionMappingValid;

        if (variant) {
          this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.form.dispatchEvent(new CustomEvent('variant:change', {
            bubbles: true,
            detail: { formId: this.form.id, variant, previousVariant }
          }));

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({ path: url.toString() }, '', url.toString());
        }
      }

      renderSummary(selections, variant) {
        const rows = [];
        this.productionPropertyInputs.filter((input) => input.checked).forEach((input) => {
          rows.push({ label: input.dataset.summaryLabel, value: input.dataset.summaryValue || input.value });
        });

        [this.finishPosition, this.sizePosition, this.quantityPosition].forEach((position) => {
          if (!position) return;
          let value = selections[position];
          if (position === this.sizePosition) value = this.formatSize(value);
          if (value) rows.push({ label: this.product.options[position - 1], value });
        });

        this.summaryList.replaceChildren(...rows.map((row) => {
          const container = document.createElement('div');
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.className = 'text-subdued';
          term.textContent = row.label;
          description.textContent = row.value;
          container.append(term, description);
          return container;
        }));
        this.summaryCompact.textContent = rows.map((row) => row.value).join(' • ');

        const units = this.parseUnits(this.selectedQuantity);
        const sets = this.setCount;
        const setLabel = sets === 1 ? this.dataset.setSingularLabel : this.dataset.setPluralLabel;
        const unitsStickerLabel = units === 1 ? this.dataset.stickerSingularLabel : this.dataset.stickerPluralLabel;
        const stickerCount = units * sets;
        const stickerLabel = stickerCount === 1 ? this.dataset.stickerSingularLabel : this.dataset.stickerPluralLabel;

        this.summarySets.hidden = !units;
        this.summaryStickerCountRow.hidden = !units;
        if (units) {
          this.summarySets.textContent = `${this.formatNumber(units)} ${unitsStickerLabel} ${this.dataset.perSetLabel} × ${this.formatNumber(sets)} ${setLabel}`;
          this.summaryStickerCount.textContent = `${this.formatNumber(stickerCount)} ${stickerLabel}`;
        }

        if (!variant) {
          this.summaryTotal.textContent = '—';
          this.summaryUnit.hidden = true;
          return;
        }

        this.summaryTotal.textContent = this.formatMoney(variant.price * sets);
        this.summaryUnit.hidden = !units;
        if (units) this.summaryUnitValue.textContent = this.formatMoney(variant.price / units);
      }

      validateSubmission(event) {
        const errors = [];
        if (!this.optionMappingValid) errors.push(this.dataset.unavailableError);
        if (!this.selectedQuantity) errors.push(this.dataset.selectQuantityError);
        if (!this.currentVariant || !this.currentVariant.available) errors.push(this.dataset.unavailableError);

        const invalidFields = Array.from(this.form.elements).filter((field) => field.willValidate && !field.checkValidity());
        invalidFields.forEach((field) => errors.push(field.dataset.validationMessage || field.validationMessage));

        if (errors.length) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showErrors(errors);
          return;
        }
      }

      showErrors(errors) {
        this.errorList.replaceChildren(...errors.map((message) => {
          const item = document.createElement('li');
          item.textContent = message;
          return item;
        }));
        this.validation.hidden = false;
        this.validation.focus();
      }

      clearErrors() {
        this.validation.hidden = true;
        this.errorList.replaceChildren();
      }

      setupModules() {
        this.querySelectorAll('[data-configurator-module="qr"]').forEach((module) => {
          const positionInputs = Array.from(module.querySelectorAll('input[type="radio"]'));
          const urlInput = this.querySelector('[data-qr-url]');
          if (!urlInput) return;

          const updateRequirement = () => {
            const selectedPosition = positionInputs.find((input) => input.checked)?.value || '';
            const requiresUrl = module.dataset.urlRequired === 'true' && selectedPosition !== module.dataset.noQrValue;
            urlInput.required = requiresUrl;
            urlInput.closest('[data-qr-destination]')?.toggleAttribute('hidden', !requiresUrl);
            if (!requiresUrl) urlInput.value = '';
          };

          positionInputs.forEach((input) => input.addEventListener('change', updateRequirement));
          updateRequirement();
        });
      }

      parseUnits(value) {
        if (!value) return 0;
        const match = String(value).replaceAll(',', '').match(/\d+(?:\.\d+)?/);
        return match ? Number(match[0]) : 0;
      }

      formatSize(value) {
        return value ? String(value).replace(/\s+Inches?$/i, '″') : value;
      }

      formatMoney(amount) {
        return new Intl.NumberFormat(this.dataset.locale, {
          style: 'currency',
          currency: this.dataset.currencyCode
        }).format(amount / 100);
      }

      formatNumber(value) {
        return new Intl.NumberFormat(this.dataset.locale).format(value);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
